import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';  // Import PropTypes explicitly
import { Layout, Box, Divider } from '@shopify/polaris';
import { bullet, check_green } from '../../../assets';

const Features = ({ appData }) => {
  const DynamicFeatures = ({ features }) => (
    <ul style={{}}> {/* Set paddingInlineStart to 0 to remove default indentation */}
      {features.map((feature, index) => (
        <li key={index} className="tw-flex tw-gap-md lg:tw-gap-md" style={{ alignItems: 'baseline', listStyle: 'none' }}>
          <span className="tw-text-3xl tw-mr-2" style={{ verticalAlign: 'top', alignItems: 'baseline', flexShrink: 0 }}>
            <img src={check_green} style={{}} alt="bullet" />
          </span>

          <span className="" style={{ lineHeight: '150%', fontSize: '18px', color: '#0B0757', fontFamily: "sfpromedium" }}>
            {feature.text && capitalizeFirstLetter(feature.text)}{(<div style={{ height: "20px" }}></div>)}
          </span>

        </li>
      ))}

    </ul>
  );



  DynamicFeatures.propTypes = {
    features: PropTypes.arrayOf(
      PropTypes.shape({
        text: PropTypes.string.isRequired,
      })
    ).isRequired,
  };

  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  useEffect(() => {
    // Your useEffect logic goes here
  }, []);

  return (
    <>



      <div className="hidden md:block">
        <div style={{ background: '#F4F7FE 0% 0% no-repeat padding-box', paddingTop: "20px" }}>
          <div className="container " >
            {appData.app_info.features && appData.app_info.features.length > 0 && (<div className="container" >


              <p className=" " style={{ fontFamily: "sfprobold", fontSize: "30px", color: '#0B0757', paddingBottom: '20px' }} >{appData.app_info.title}</p>

              <span className=""
                style={{ lineHeight: '200%', fontFamily: "sfproregular", fontSize: '18px', color: '#5A5A5A', }}>
                <span className="" style={{ lineHeight: '200%', fontFamily: "sfproregular", fontSize: '18px', color: '#5A5A5A' }}>
                  {appData.app_info && appData.app_info.description ? capitalizeFirstLetter(appData.app_info.description) : null}
                </span>

              </span>
              <div className="tw-mt-5" style={{ paddingBottom: '10px' }}>
                {appData.app_info.features && appData.app_info.features.length > 0 && (
                  <DynamicFeatures features={appData.app_info.features.map(feature => ({ text: feature }))} />
                )}
              </div>



            </div>)}
          </div>
          <div style={{ height: "10px" }}></div>
        </div>
      </div>

      {/* Second div - Show on mobile view */}
      <div className="block md:hidden">
        <div style={{ background: '#F4F7FE 0% 0% no-repeat padding-box', paddingTop: "20px" }}>
          <div className="container " >
            {appData.app_info.features && appData.app_info.features.length > 0 && (<div className="container " style={{ paddingBottom: '0px' }} >


              <p className=" " style={{ fontFamily: "sfprobold", fontSize: "30px", color: '#0B0757', paddingBottom: '20px' }} >{appData.app_info.title}</p>

              <span className=""
                style={{ lineHeight: '200%', fontFamily: "sfproregular", fontSize: '18px', color: '#5A5A5A', }}>
                <span className="" style={{ lineHeight: '200%', fontFamily: "sfproregular", fontSize: '18px', color: '#5A5A5A' }}>
                  {appData.app_info && appData.app_info.description ? capitalizeFirstLetter(appData.app_info.description) : null}
                </span>

              </span>
              <div className="tw-mt-5" style={{ paddingBottom: '25px' }}>
                {appData.app_info.features && appData.app_info.features.length > 0 && (
                  <DynamicFeatures features={appData.app_info.features.map(feature => ({ text: feature }))} />
                )}
              </div>



            </div>)}
          </div>
          <div style={{ height: "10px" }}></div>
        </div>
      </div>
    </>
  );
};

Features.propTypes = {
  appData: PropTypes.shape({
    title: PropTypes.string.isRequired,
    app_id: PropTypes.string.isRequired,
    app_name: PropTypes.string.isRequired,
    app_info: PropTypes.string.isRequired,
    description: PropTypes.string, // Optional, adjust the type accordingly
    list_of_categories: PropTypes.arrayOf(PropTypes.any), // Optional, adjust the type accordingly
    // Add other required properties here
  }).isRequired,
};

export default Features;
